<template>
    <div class="modal fade" id="confirmHideSingleProduct" tabindex="-1" role="dialog" aria-labelledby="confirmHideProduct1" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content campaign-g-addedit">
                <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLongTitle">{{hideHeaderMsg ? hideHeaderMsg : 'Hide Product'}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click = "closePopUpAction">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <p>{{ isDiffMsg ? isDiffMsg : ( notHidden ? 'Cannot Hide The Product' : 'Are you sure, you want to hide?')}}</p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" @click = "closePopUpAction">No</button>
                    <button type="button" @click="hideProducts" class="btn btn-primary" data-dismiss="modal">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'HideProductConfirmModal',
    data() {
        return {

        }
    },
    props: {
		isDiffMsg:String,
		notHidden : Boolean,
		hideHeaderMsg: String
    },
    methods: {
        hideProducts() {
			// if(this.notHidden){
			// 	$('#confirmHideProduct').modal('hide')
			// }else{
				this.$emit('hideProducts')
			// }
        },
		closePopUpAction(){
            this.$emit("closeActiveRuleModal")
            this.$emit("hideAction")
		}
    },
}
</script>

<style lang="scss">

</style>
